export default __webpack_public_path__ + "img/2ae35ea778e4da5aff59ab914baa27f3.svg";